export default class BookmarkStorage {
  // where all bookmarks should live
  static bookmarkNavSelector = "#main-nav-bookmarks";
  static config = {
    storageKey: process.env.BOOKMARKS_STORAGE_KEY,
    renderAttribute: true,
  };
  constructor() {
    if (!this.storageAvailable("localStorage")) {
      console.log("No local storage available");
    } else {
      // get all bookmarks
      this.getBookmarks();
    }
  }

  storageAvailable(type) {
    try {
      var storage = window[type],
        x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  }

  // store a single bookmark
  addBookmark(data) {
    this.list.push(data);
    this.storeBookmarks();
  }

  // toggle to bookmark in storage, return true if added, false if deleted
  toggleBookmark(data) {
    if (!this.isBookmarked(data?.id)) {
      this.addBookmark(data);
      return true;
    } else {
      this.deleteBookmark(data);
      return false;
    }
  }

  // toggle the active class name on a target event
  toggleActive(target, isActive = false) {
    if (!isActive) {
      target.setAttribute("aria-pressed", false);
      target.classList.remove(this.config.activeClass);
    } else {
      target.setAttribute("aria-pressed", true);
      target.classList.add(this.config.activeClass);
    }
  }
  // toggle the navigation class to display the orange dot or not (updated or not)
  renderNavAttribute() {
    let bookmarkClass = document.querySelector(
      BookmarkStorage.bookmarkNavSelector
    );
    if (bookmarkClass) {
      if (this.list.length) {
        bookmarkClass.classList.add("updated");
      } else bookmarkClass.classList.remove("updated");
    }
  }

  // store all bookmarks
  storeBookmarks() {
    localStorage.setItem(
      BookmarkStorage.config.storageKey,
      JSON.stringify(this.list)
    );
    this.getBookmarks();
  }

  // delete a single bookmark
  deleteBookmark(data) {
    this.list = this.list.filter(function (e) {
      return e.id != data.id;
    });
    this.storeBookmarks();
  }

  updateBookmark(data) {
    // if this already exists in local storage, delete and re-add it
    var foundIndex = this.list.findIndex((x) => x.id == data.id);
    if (foundIndex > -1) {
      this.list[foundIndex] = data;
      this.storeBookmarks();
    } else {
      this.addBookmark(data);
    }
  }

  // get a list of bookmarks from local storage
  getBookmarks() {
    const items = localStorage.getItem(BookmarkStorage.config.storageKey);
    let list = null;
    if (items) {
      list = JSON.parse(
        localStorage.getItem(BookmarkStorage.config.storageKey)
      );
    }
    this.list = list ? list : [];
    if (BookmarkStorage.config.renderAttribute) this.renderNavAttribute();
  }

  // check if bookmark exists with current asset id
  isBookmarked(id) {
    let isBookmarked = false;
    if (this.list.length) {
      const exists = this.list.find((l) => l.id == id);
      isBookmarked = exists?.id ? true : false;
    }
    return isBookmarked;
  }
}
